import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const installmentSelectorStyles = {
  fieldset: {
    border: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.extraSmall,
  } as CSSProperties,

  legend: {
    marginBottom: theme.spacing.medium,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: theme.typography.lineHeight.lg,
    color: theme.colors.label,
    padding: 0,
  } as CSSProperties,

  statusText: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.placeholder,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  errorText: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.error,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  errorRow: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    alignItems: 'center',
    gap: theme.spacing.small,
    marginBottom: theme.spacing.extraSmall,
  } as CSSProperties,

  retryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing.extraSmall,
    padding: `${theme.spacing.extraSmall}px ${theme.spacing.small}px`,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: 9999,
    background: theme.colors.background,
    color: theme.colors.label,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    cursor: 'pointer',
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,
};
